/*
 * Insignia de estado de una fila (llegada, almuerzo, salida). tone: 'up' | 'neutral' | 'down' | 'muted'.
 * Lleva ícono y texto además del color (accesible para quien no distingue verde y salmón).
 */
import React from "react";

const ICONS = {
    up: 'bx bx-check-circle',
    neutral: 'bx bx-check',
    down: 'bx bx-error-circle',
    muted: 'bx bx-minus-circle',
};

const StatusBadge = ({tone = 'neutral', text}) => (
    <span className={`mc-badge mc-badge--${tone}`}>
        <i className={ICONS[tone] || ICONS.neutral} aria-hidden="true"/>
        {text}
    </span>
);

export default StatusBadge;
